"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const useAddtionalInfoEDS = () => {
    const [patchCreditApplication, { data: respPatchCreditApplication, isLoading: isLoadingPatchCreditApplication, },] = (0, consumer_applications_v2_api_1.usePatchConsumerApplicationsV2CreditApplicationsApplicationIdMutation)();
    const [postNextLender, { data: respNextLender, isLoading: isLoadingNextLender },] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2PrequalificationsApplicationIdNextLenderMutation)();
    return {
        patchCreditApplication,
        respPatchCreditApplication,
        isLoadingPatchCreditApplication,
        postNextLender,
        respNextLender,
        isLoadingNextLender,
    };
};
exports.default = useAddtionalInfoEDS;
